<template>
  <div class="yxtbiz-select-kng-catalog-v2">
    <div class="yxtbiz-select-kng-catalog-v2__main-content" :class="{ 'pr280': isShowCheckedList }">
      <yxt-input
        v-if="isShowSearch"
        class="mb16 yxtbiz-select-kng-catalog-v2__search"
        v-model="searchCatalogName"
        :placeholder='$t("pc_biz_kng_lbl_search_category_name"/* 搜索分类名称 */)'
        maxlength="20"
        searchable
        @search="searchCatalog"
      />
      <yxtbiz-funs-tree
        ref="tree"
        v-loading="treeLoading"        
        :data="treeData"
        virtual
        :keeps="50"
        :buffer="10"
        node-key="id"
        :default-expanded-keys="defaultExpandCatalog"
        :default-checked-keys="defaultCheckKeys"
        :props="defaultProps"
        :highlight-current="!showCheckbox"
        :show-checkbox="showCheckbox"
        :check-strictly="checkStrictly"
        :wrapWidth="wrapWidth"
        :functionsRender="functionsRenderMid"
        :filter-node-method="filterCatalogNode"
        @node-click="nodeClick"
        @check="handlerCheck"
      >
      </yxtbiz-funs-tree>
    </div>
    <div v-if="isShowCheckedList" class="yxtbiz-select-kng-catalog-v2__checked-list">
      <div class="yxtbiz-select-kng-catalog-v2__checked-list-header">
        <span>{{$t('pc_biz_labelling_selected'/** 已选： */)}} {{ selectData.length }}</span>
        <yxt-button v-if="showClearAllBtn" type="text" @click="clearAll">{{$t('pc_biz_labelling_clearall'/** 清空 */)}}</yxt-button>
      </div>
      <div  class="yxtbiz-select-kng-catalog-v2__checked-list-content mt16">
        <yxt-tag v-for="(item, key) in showData"
          :key="key"
          class="mr5 mb6"
          size="small"
          type="info"          
          :disableTransitions="true"
          closable
          @close="deleteItem(item)"
          >
          <yxt-tooltip effect="dark" placement="top" :content="item.label">
            <span>{{ item.label }}</span>
          </yxt-tooltip>          
          <span v-if="item.includeAll === 1" class="ml8 color-gray-6">{{ $t('biz_udp_subsequent_all'/** 后续全部 */) }}</span>
        </yxt-tag>

        <div v-if="showCount < selectData.length">
          <yxt-tag class="pointer"
            size="small"
            type="info"
            :disableTransitions="true"
            @click="() => { showCount += 50; }"
            >
              <span class="checkedlist-tag">{{$t('biz_pc_expand_more'/** 展开更多 */)}}</span>
              <i class="yxt-icon-arrow-down ml6"></i>
          </yxt-tag>
        </div>
        <div v-if="showCount > selectData.length && selectData.length > 6">
          <yxt-tag class="pointer"
            size="small"
            type="info"
            :disableTransitions="true"
            @click="() => { showCount = 6; }"
            >
              <span class="checkedlist-tag">{{$t('app_common_yxt_btn_close'/** 收起 */)}}</span>
              <i class="yxt-icon-arrow-up ml6"></i>
          </yxt-tag>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getKngTreeNew } from './service';
import { formatObj } from './util';
import { enmuFunctions } from '../../function-points';
import commonUtil from '../../common-util';

export default {
  name: 'YxtbizSelectKngCatalogV2',
  name_zh: '选择课程分类',
  eventList: [{
    type: 'change',
    handler: 'current-node-change',
    label: '选中节点变更'
  }],
  props: {
    collegeId: {
      type: String,
      default: '',
      desc: '学院ID 如果不传获取全部的目录',
      setter: 'StringSetter'
    },
    pmType: {
      type: Number,
      default: 0,
      desc: '需要目录的权限(0 浏览;1下载;2分发;3上传;4维护;5审核)',
      setter: 'SelectSetter',
      enums: [
        {
          label: '浏览',
          value: 0
        },
        {
          label: '下载',
          value: 1
        },
        {
          label: '分发',
          value: 2
        },
        {
          label: '上传',
          value: 3
        },
        {
          label: '维护',
          value: 4
        },
        {
          label: '审核',
          value: 5
        },
        {
          label: 'App缓存课件',
          value: 6
        }
      ]
    },
    checkMode: {
      type: Number,
      default: 0,
      desc: '选择模式，0：单选、1：多选，显示复选框、2：多选，支持选择当前全部和后续全部',
      setter: 'TabSetter',
      enums: [
        {
          label: '单选',
          value: 0
        },
        {
          label: '多选，显示复选框',
          value: 1
        },
        {
          label: '多选，支持选择当前全部和后续全部',
          value: 2
        }
      ]
    },
    checkList: {
      type: Array,
      default: () => [],
      desc: '多选时初始化默认勾选的选项',
      setter: 'JsonSetter'
    },
    checkId: {
      type: String,
      default: '',
      desc: '单选时初始化传入组件的默认选中id',
      setter: 'StringSetter'
    },
    isExpandCatalog: {
      type: Boolean,
      default: false,
      desc: '是否展开一级分类',
      setter: 'BooleanSetter'
    },
    isShowSearch: {
      type: Boolean,
      default: false,
      desc: '是否显示搜索框',
      setter: 'BooleanSetter'
    },
    showCheckedList: {
      type: Boolean,
      default: false,
      desc: '是否显示右侧选中列表栏，checkMode===2时有效',
      setter: 'BooleanSetter'
    },
    wrapWidth: {
      type: [String, Number],
      default: '100%',
      desc: '树的宽度设置',
      setter: 'StringSetter'
    },
    isShowDisabledCollege: {
      type: Boolean,
      default: false,
      desc: '如果希望在企课堂被禁用或者已过期后仍然能选择到子课堂目录的话，这个值传true。',
      setter: 'BooleanSetter'
    }
  },
  data() {
    return {
      searchCatalogName: '',
      treeLoading: true, // loading-tree
      treeData: [], // 目录树的数据
      defaultProps: {
        children: 'children', // 默认子集的字段
        label: 'label', // 默认标题的字段
        nocheck: this.noCheckFilter
      },
      singleTree: {},
      noCheckList: [], // 不可选的列表 用于过滤不可点击
      defaultExpandCatalog: [], // 需要展开节点的列表
      defaultCheckKeys: [], // 默认选中的keys
      showCheckbox: false,
      checkStrictly: false,
      selectData: [],
      showCount: 6
    };
  },
  computed: {
    isShowCheckedList() {
      return this.showCheckedList && this.checkMode === 2;
    },
    showClearAllBtn() {
      return this.selectData && this.selectData.length;
    },
    showData() {
      return this.selectData.slice(0, this.showCount);
    }
  },
  watch: {
    // 选择模式，0：单选、1：多选，显示复选框、2：多选，支持选择当前全部和后续全部
    checkMode: {
      handler(val) {
        if (val === 1) {
          this.showCheckbox = true;
          this.checkStrictly = false;
        } else if (val === 2) {
          this.showCheckbox = true;
          this.checkStrictly = true;
        } else {
          this.showCheckbox = false;
          this.checkStrictly = false;
        }
      },
      immediate: true
    }
  },
  async mounted() {
    await commonUtil.preCheckFunctions(enmuFunctions);
    this.initData();
  },
  methods: {
    async initData() {
      try {
        this.treeLoading = true;
        const params = {
          pmType: this.pmType,
          filter: this.filterClosedCollegeData ? 1 : 0,
          collegeId: this.collegeId
        };
        let res = await getKngTreeNew(params);
        const collegeCode = commonUtil.checkTimeOutFnc(enmuFunctions.ONLINE_ClASS_SELECT_CATALOG);
        // 如果未增购企课堂，只显示主学院，如果传参要求显示禁用课堂就不再过滤
        if (![2, 3, 4].includes(collegeCode) && !this.isShowDisabledCollege) {
          res = res.filter(item => item.mainCollege);
        }
        this.treeData = res;
        // 展开第一层目录
        if (this.isExpandCatalog) {
          this.$nextTick(()=>{
            this.defaultExpandCatalog = res.map(item => item.id);
          });
        }
        // 如果显示复选框的情况下，默认不可选根目录(课堂)
        if ([1, 2].includes(this.checkMode)) {
          this.noCheckList = res.map(item => item.id);
        }

        // 设置选中
        if (this.checkMode === 0 && this.checkId) {
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.checkId);
            this.singleTree = this.$refs.tree.getCurrentNode();
          });
        } else if (this.checkList && this.checkList.length) {
          if (this.checkMode === 1) {
            this.defaultCheckKeys = this.checkList.map(item => typeof item === 'object' ? item.id : item);
          } else if (this.checkMode === 2) {
            this.$nextTick(() => {
              this.checkList.forEach(item => {
                if (typeof item === 'object') {
                  let node = this.$refs.tree.getNode(item.id);
                  if (node) {
                    if (item.includeAll === 1) {
                      this.setChildrenInclude(node, node.data, 1, false);
                    } else {
                      this.setNodeChecked(node);
                    }
                  }
                }
              });
            });
          }
        }

        this.treeLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
    // 根据分类名称过滤分类树
    filterCatalogNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 搜索框触发事件
    searchCatalog(value) {
      this.$refs.tree && this.$refs.tree.filter(value);
    },
    // 检查节点是否显示复选框
    noCheckFilter(data) {
      return this.noCheckList.includes(data.id);
    },
    // 单击目录时的选择
    nodeClick(item) {
      // 如果选择了一级目录 取消选中
      if (this.noCheckList.includes(item.id)) {
        this.$refs.tree.setCurrentKey(null);
        return false;
      }
      this.singleTree = item;
      this.$emit('current-node-change', item.id, item);
    },
    // 获取选中树数据id
    getCheckTree() {
      if (this.checkMode === 1) {
        if (this.$refs.tree) {
          let treeLists = this.$refs.tree.getCheckedNodes();
          return treeLists.map(({ label, id }) => ({ label, id }));
        }
        return [];
      } else if (this.checkMode === 2) {
        return this.selectData.map(({ label, id, includeAll }) => ({ label, id, includeAll }));
      } else {
        return this.singleTree || [];
      }
    },
    // 树节点选中处理
    handlerCheck(...argu) {
      if (this.checkMode === 2) {
        let node = this.$refs.tree.getNode(argu[0]);
        if (node.checked) {
          this.setChildrenInclude(node, node.data, 1, false);
        } else {
          this.setChildrenInclude(node, node.data, 0, true);
        }
      }
    },
    // 做右侧功能列表
    functionsRenderMid(node, data) {
      let arr = [];
      if (!data.parentId || this.checkMode !== 2 || (data.parent && data.parent.includeAll === 1)) {
        return arr;
      }
      arr.push({
        label: this.$t('pc_biz_lbl_includeall'/** 当前及后续新增分类 */),
        handler: this.setChildrenInclude,
        disabled: !!(node.parent && node.parent.data.includeAll)
      });
      arr.push({
        label: this.$t('biz_shoptour_curr_all_area'/** 当前全部 */),
        handler: this.setChildrenWithout,
        disabled: !!(node.parent && node.parent.data.includeAll)
      });
      arr.push({
        label: node.checked ? this.$t('pc_biz_lbl_cancel_cur_catalog'/** 取消当前节点分类 */) : this.$t('pc_biz_lbl_cur_node_catalog'/** 当前节点分类 */),
        handler: this.setNodeChecked,
        disabled: !!(node.parent && node.parent.data.includeAll)
      });
      return arr;
    },
    // 当前及后续新增分类
    setChildrenInclude(node, data, includeAll = 1, f) {
      let userChecked = this.$refs.tree.getCheckedNodes();
      let datas = this.getDescendantList(node, includeAll);
      if (!f) {
        const setDatas = [...datas, ...userChecked];
        this.$refs.tree.setCheckedNodes(setDatas);
      } else {
        const { routingPath } = data;
        const treeData = [];
        const resetTreeData = userChecked.filter(item => {
          if (item.routingPath.includes(routingPath)) {
            item.disabled = false;
            return true;
          } else {
            treeData.push({ ...item });
            return false;
          }
        });
        this.$refs.tree.setCheckedNodes(resetTreeData); // 取消当前节点的子节点禁用
        this.$refs.tree.setCheckedNodes(treeData); // 重新设置选中状态，只设置 没被取消选中 的
      }
      this.handleSelectData(node, 1);
    },
    // 当前全部
    setChildrenWithout(node, data) {
      let datas = this.getDescendantList(node, 0);
      let userChecked = this.$refs.tree.getCheckedNodes();
      this.$refs.tree.setCheckedNodes([...datas, ...userChecked]);
      this.handleSelectData(node, 2);
    },
    // 当前节点分类/取消当前节点分类
    setNodeChecked(node) {
      if (node.checked && node.data.includeAll) {
        this.setChildrenInclude(node, node.data, 0, true);
      } else {
        this.$refs.tree.setChecked(node.data.id, !node.checked);
        this.handleSelectData(node, 3);
      }
    },
    // 设置当前节点及下级所有节点的状态
    getDescendantList(node, includeAll = 0) {
      let arr = [];
      node.data.includeAll = includeAll;
      arr.push(node.data);
      this.getChildLoop(node, arr, includeAll);
      return arr;
    },
    // 下级子节点设置(同时禁用)
    getChildLoop(node, arr, includeAll) {
      if (!node.childNodes) {
        return;
      }
      node.childNodes.forEach(n => {
        n.data.disabled = includeAll === 1;
        n.data.includeAll = includeAll;
        arr.push(n.data);
        if (n.childNodes.length > 0) {
          this.getChildLoop(n, arr, includeAll);
        }
      });
    },
    // 处理选择数据
    handleSelectData(node, isCurrent) {
      let idsObj = formatObj(node, 'childNodes');
      let newCatalog = [...this.selectData];
      const catalogIds = new Map();
      newCatalog.forEach(item => catalogIds.set(item.id, item));

      if (isCurrent === 1) { // 当前及后续新增分类
        const excludeIds = new Set();
        idsObj.forEach((item, index) => {
          // 后续全部展示区域只保存第一个
          if (index === 0) {
            const catalog = catalogIds.get(item.id);
            if (!catalog) {
              newCatalog.push(item);
            } else if (catalog.includeAll === 0) { // 取消选择
              excludeIds.add(item.id);
            }
          } else {
            excludeIds.add(item.id);
          }
        });
        newCatalog = newCatalog.filter(item => !excludeIds.has(item.id));
      } else if (isCurrent === 2) { // 当前全部
        idsObj.forEach(item => {
          const catalog = catalogIds.get(item.id);
          if (!catalog) {
            newCatalog.push(item);
          } else {
            // 之前选过的，为了防止不破坏列表展示tag顺序
            catalog.includeAll = 0;
          }
        });
      } else if (isCurrent === 3) { // 当前节点分类/取消当前节点分类
        const excludeIds = new Set();
        if (node.checked) {
          newCatalog.push(idsObj[0]);
        } else {
          excludeIds.add(node.data.id);
        }
        newCatalog = newCatalog.filter(item => !excludeIds.has(item.id));
      }
      this.selectData = newCatalog;
    },
    // 删除当前项
    deleteItem(item) {
      if (this.checkMode === 2) {
        let node = this.$refs.tree.getNode(item.id);
        if (node) {
          if (item.includeAll === 1) {
            this.setChildrenInclude(node, node.data, 0, true);
          } else {
            this.setNodeChecked(node);
          }
        }
      }
    },
    // 清除所有已选项
    clearAll() {
      if (this.checkMode === 2) {
        this.selectData = [];
        const userChecked = this.$refs.tree.getCheckedNodes();
        userChecked.forEach(item => {
          item.disabled = false;
          item.includeAll = 0;
        });
        this.$refs.tree.setCheckedNodes([]);
      }
    }
  }
};
</script>
